module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('em', [_vm._v("Chief Abbreviations")])])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ABR")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Australian Biblical Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Achtemeier")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Paul J. Achtemeier: "), _c('em', [_vm._v("Romans")]), _vm._v(" (Atlanta, 1985)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Alford")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Henry Alford: "), _c('em', [_vm._v("The Greek Testament"), _c('sup', [_vm._v("7")])]), _vm._v(" (London, 1874)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Althaus")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Paul Althaus: "), _c('em', [_vm._v("Der Brief an die Römer")]), _vm._v(" (Göttingen, 1970)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ANF")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ante-Nicene Fathers (American repr. of the Edinburgh edn.; Grand Rapids, n.d.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ARV")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The American Revised Version")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("AS")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("G. Abbott-Smith: "), _c('em', [_vm._v("A Manual Greek Lexicon of the New Testament")]), _vm._v(" (Edinburgh, 1954)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ASV")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The American Standard Version")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BAGD")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Walter Bauer: "), _c('em', [_vm._v("A Greek-English Lexicon of the New Testament and Other Early Christian Literature,")]), _vm._v(" rev. and aug. by F. Wilbur Gingrich and Frederick W. Danker from the 5th edn. (Chicago, 1979)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Barclay")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("William Barclay: "), _c('em', [_vm._v("The Letter to the Romans")]), _vm._v(" (Edinburgh, 1957)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Barrett")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("C. K. Barrett: "), _c('em', [_vm._v("A Commentary on the Epistle to the Romans")]), _vm._v(" (London, 1957)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Barth")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Karl Barth: "), _c('em', [_vm._v("The Epistle to the Romans")]), _vm._v(" (Oxford, 1933)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BDF")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("F. Blass and A. Debrunner: "), _c('em', [_vm._v("A Greek Grammar of the New Testament,")]), _vm._v(" trans, and rev. R. W. Funk (Chicago, 1961)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bengel")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("John Albert Bengel: "), _c('em', [_vm._v("Gnomon of the New Testament,")]), _vm._v(" II (Edinburgh, 1873)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Black")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Matthew Black: "), _c('em', [_vm._v("Romans")]), _vm._v(" (London, 1973)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bowen")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Roger Bowen: "), _c('em', [_vm._v("A Guide to Romans")]), _vm._v(" (London, 1975)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Boylan")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Patrick Boylan: "), _c('em', [_vm._v("St. Paul’s Epistle to the Romans")]), _vm._v(" (Dublin, 1947)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Brown")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("John Brown: "), _c('em', [_vm._v("Analytical Exposition of the Epistle of Paul the Apostle to the Romans")]), _vm._v(" (Grand Rapids, 1981 repr. of 1857 edn.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bruce")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("F. F. Bruce: "), _c('em', [_vm._v("The Letter of Paul to the Romans"), _c('sup', [_vm._v("2")])]), _vm._v(" (Leicester, 1985)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Brunner")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Emil Brunner: "), _c('em', [_vm._v("The Letter to the Romans")]), _vm._v(" (London, 1959)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Calvin")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("John Calvin: "), _c('em', [_vm._v("The Epistles of Paul the Apostle to the Romans and to the Thessalonians")]), _vm._v(" (Edinburgh, 1961)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CBQ")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Catholic Biblical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CBSC")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The Cambridge Bible for Schools and Colleges")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CGT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Cambridge Greek Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Chamberlain")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("William Douglas Chamberlain: "), _c('em', [_vm._v("An Exegetical Grammar of the Greek New Testament")]), _vm._v(" (New York, 1941)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Christian Words")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nigel Turner: "), _c('em', [_vm._v("Christian Words")]), _vm._v(" (Edinburgh, 1980)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("Cragg")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Interpreter’s Bible,")]), _vm._v(" IX, “The Epistle to the Romans,” exposition by Gerald R. Cragg")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Cranfield")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("C. Ε. B. Cranfield: "), _c('em', [_vm._v("A Critical and Exegetical Commentary on the Epistle to the Romans")]), _vm._v(" (Edinburgh, I [1975]; II [1979])")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Denney")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("James Denney: “St. Paul’s Epistle to the Romans” in "), _c('em', [_vm._v("The Expositor’s Greek Testament,")]), _vm._v(" II (Grand Rapids, 1979 repr.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("DM")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("H. E. Dana and Julius R. Mantey: "), _c('em', [_vm._v("A Manual Grammar of the Greek New Testament")]), _vm._v(" (New York, 1927)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Dodd")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("C. H. Dodd: "), _c('em', [_vm._v("The Epistle of Paul to the Romans")]), _vm._v(" (London, 1944)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Donfried")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Karl P. Donfried: "), _c('em', [_vm._v("The Romans Debate")]), _vm._v(" (Minneapolis, 1977)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Earle")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ralph Earle: "), _c('em', [_vm._v("Word Meanings in the New Testament,")]), _vm._v(" III, "), _c('em', [_vm._v("Romans")]), _vm._v(" (Grand Rapids, 1974)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("EGT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("W. Robertson Nicoll, ed.: "), _c('em', [_vm._v("The Expositor’s Greek Testament,")]), _vm._v(" 5 vols. (Grand Rapids, 1979 repr.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ET")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Expository Times")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Foreman")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("K. J. Foreman: "), _c('em', [_vm._v("Romans, I & II Corinthians")]), _vm._v(" (London, 1962)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Gamble")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Harry Gamble, Jr. : "), _c('em', [_vm._v("The Textual History of the Letter to the Romans")]), _vm._v(" (Grand Rapids, 1977)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Gifford")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ε. H. Gifford: "), _c('em', [_vm._v("The Epistle of St. Paul to the Romans")]), _vm._v(" (London, 1886)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("GNB")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Good News Bible (Today’s English Version)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Godet")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("F. Godet: "), _c('em', [_vm._v("Commentary on St. Paul’s Epistle to the Romans,")]), _vm._v(" 2 vols. (Edinburgh, 1895)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Goodspeed")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Edgar J. Goodspeed: "), _c('em', [_vm._v("The New Testament: An American Translation")]), _vm._v(" (Chicago, 1923)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Gore")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Charles Gore: "), _c('em', [_vm._v("St. Paul’s Epistle to the Romans,")]), _vm._v(" 2 vols. (London, I [1902]; II [1907])")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Grammatical Insights")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nigel Turner: "), _c('em', [_vm._v("Grammatical Insights into the New Testament")]), _vm._v(" (Edinburgh, 1965)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Griffith")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Gwilym O. Griffith: "), _c('em', [_vm._v("St. Paul’s Gospel to the Romans")]), _vm._v(" (Oxford, 1949)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("GT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("A Greek-English Lexicon of the New Testament,")]), _vm._v(" being Grimm’s Wilke’s "), _c('em', [_vm._v("Clavis Novi Testamenti,")]), _vm._v(" trans, and rev. J. H. Thayer (Edinburgh, 1888)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Haldane")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Robert Haldane: "), _c('em', [_vm._v("The Epistle to the Romans")]), _vm._v(" (London, 1966 repr.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Harrison")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Everett F. Harrison: “Romans” in "), _c('em', [_vm._v("The Expositor’s Bible Commentary,")]), _vm._v(" 10 (Grand Rapids, 1976)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Harrisville")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Roy A. Harrisville: "), _c('em', [_vm._v("Romans")]), _vm._v(" (Minneapolis, 1980)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hendriksen")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("William Hendriksen: "), _c('em', [_vm._v("New Testament Commentary: Exposition of Paul’s Epistle to the Romans")]), _vm._v(" (Grand Rapids, I [1980]; II [1981])")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hodge")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Charles Hodge: "), _c('em', [_vm._v("A Commentary on Romans")]), _vm._v(" (London, 1972 repr. of 1864 edn.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hunter")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("A. M. Hunter: "), _c('em', [_vm._v("The Epistle to the Romans")]), _vm._v(" (London, 1975)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("IBNTG")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("C. F. D. Moule: "), _c('em', [_vm._v("An Idiom Book of New Testament Greek")]), _vm._v(" (Cambridge, 1953)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("IDB")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Interpreter’s Dictionary of the Bible,")]), _vm._v(" 4 vols. (Nashville, 1962); Supplementary Volume (1976)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  })])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JB")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Jerusalem Bible")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JBL")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Journal of Biblical Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JTS")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Journal of Theological Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Käsemann")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ernst Käsemann: "), _c('em', [_vm._v("Commentary on Romans")]), _vm._v(" (Grand Rapids, 1980)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Kertelge")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Karl Kertelge and Gerhard Schneider: "), _c('em', [_vm._v("The Epistles to the Romans and Galatians for Spiritual Reading")]), _vm._v(" (London, 1977)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Knox")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Interpreter’s Bible,")]), _vm._v(" IX, introduction and exegesis by John Knox (Nashville, 1978)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Knox, R")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("R. Knox: "), _c('em', [_vm._v("The Holy Bible, A Translation from the Latin Vulgate")]), _vm._v(" (London, 1955)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LAE")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("A. Deissmann: "), _c('em', [_vm._v("Light from the Ancient East")]), _vm._v(" (London, 1927)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lagrange")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("M.-J. Lagrange: "), _c('em', [_vm._v("Saint Paul Épitre aux Romains")]), _vm._v(" (Paris, 1922)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LB")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Living Bible")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Leenhardt")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Franz J. Leenhardt: "), _c('em', [_vm._v("The Epistle to the Romans")]), _vm._v(" (London, 1961)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lenski")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("R. C. H. Lenski: "), _c('em', [_vm._v("The Interpretation of St. Paul’s Epistle to the Romans")]), _vm._v(" (Minneapolis, n.d.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lightfoot")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("J. B. Lightfoot: Noies "), _c('em', [_vm._v("on Epistles of St Paul")]), _vm._v(" (London, 1904)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lloyd-Jones")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("D. M. Lloyd-Jones: "), _c('em', [_vm._v("Romans: An Exposition of Chapters 3:20-8:39,")]), _vm._v(" 6 vols. (London, 1970-75)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Loane")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Marcus Loane: "), _c('em', [_vm._v("God’s Mere Mercy")]), _vm._v(" (Blackwood, South Australia, 1986)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LSJ")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("A Greek-English Lexicon,")]), _vm._v(" comp. H. G. Liddell and R. Scott, rev. H. S. Jones and R. McKenzie, 2 vols. (Oxford, 1940)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Luther")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Martin Luther: "), _c('em', [_vm._v("Lectures on Romans")]), _vm._v(" (Library of Christian Classics; London, 1961)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LXX")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The Septuagint")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("M, I")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("J. H. Moulton: "), _c('em', [_vm._v("A Grammar of New Testament Greek,")]), _vm._v(" I, "), _c('em', [_vm._v("Prolegomena")]), _vm._v(" (Edinburgh, 1906)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Μ, Π")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ibid.,")]), _vm._v(" II, "), _c('em', [_vm._v("Accidence and Word-Formation,")]), _vm._v(" ed. W. F. Howard (Edinburgh, 1919)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Μ, ΠΙ")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ibid.,")]), _vm._v(" Ill, "), _c('em', [_vm._v("Syntax,")]), _vm._v(" by Nigel Turner (Edinburgh, 1963)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("M, IV")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ibid.,")]), _vm._v(" IV, "), _c('em', [_vm._v("Style,")]), _vm._v(" by Nigel Turner (Edinburgh, 1976)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Manson")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("T. W. Manson: “Romans” in "), _c('em', [_vm._v("Peake’s Commentary on the Bible,")]), _vm._v("ed. Matthew Black and H. H. Rowley (London, 1980)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Metzger")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bruce M. Metzger: "), _c('em', [_vm._v("A Textual Commentary on the Greek NewTestament")]), _vm._v(" (London and New York, 1971)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Michel")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Otto Michel: "), _c('em', [_vm._v("Der Brief an die Römer")]), _vm._v(" (Göttingen, 1966)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Minear")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Paul S. Minear: "), _c('em', [_vm._v("The Obedience of Faith")]), _vm._v(" (London, 1971)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("MM")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("J. H. Moulton and G. Milligan: "), _c('em', [_vm._v("The Vocabulary of the GreekTestament")]), _vm._v(" (London, 1914-29)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Moffatt")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("James Moffatt: "), _c('em', [_vm._v("The New Testament: A New Translation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Morison")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("James Morison: "), _c('em', [_vm._v("A Critical Exposition of the Third Chapter of Paul’s Epistle to the Romans")]), _vm._v(" (London, 1866)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Moule")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Handley C. G. Moule: "), _c('em', [_vm._v("The Epistle of St. Paul to the Romans")]), _vm._v(" (London, 1896)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("MS(S)")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Manuscript(s)")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("MT")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ernest de Witt Burton: "), _c('em', [_vm._v("Syntax of the Moods and Tenses in New Testament Greek")]), _vm._v(" (Edinburgh, 1955)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Murray")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("John Murray: "), _c('em', [_vm._v("The Epistle to the Romans,")]), _vm._v(" 2 vols. (Grand Rapids, 1960 and 1965)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NASB")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The New American Standard Bible")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NBCR")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The New Bible Commentary Revised,")]), _vm._v(" ed. D. Guthrie "), _c('em', [_vm._v("et al.")]), _vm._v(" (London, 1970)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NEB")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The New English Bible")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NIDNTT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The New International Dictionary of New Testament Theology,")]), _vm._v(" ed. Colin Brown, 3 vols. (Exeter, 1975-78)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NIV")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("New International Version")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NPNF")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nicene and Post-Nicene Fathers")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NTS")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("New Testament Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nygren")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Anders Nygren: "), _c('em', [_vm._v("Commentary on Romans")]), _vm._v(" (London, 1952)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Olshausen")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hermann Olshausen: "), _c('em', [_vm._v("Studies in the Epistle to the Romans")]), _vm._v(" (Minneapolis, 1983 repr. of 1849 edn.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("O’Neill")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("J. C. O’Neill: "), _c('em', [_vm._v("Paul’s Letter to the Romans")]), _vm._v(" (Harmondsworth, 1975)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Parry")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("R. St John Parry: "), _c('em', [_vm._v("The Epistle of Paul the Apostle to the Romans")]), _vm._v(" (Cambridge, 1912)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Phillips")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("J. B. Phillips: "), _c('em', [_vm._v("Letters to Young Churches")]), _vm._v(" (Melbourne, 1952)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Rhymer")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Joseph Rhymer: "), _c('em', [_vm._v("Good News in Romans")]), _vm._v(" (London, 1974)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ridderbos")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Herman Ridderbos: "), _c('em', [_vm._v("Paul")]), _vm._v(" (Grand Rapids, 1975)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Robertson")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("A. T. Robertson: "), _c('em', [_vm._v("A Grammar of the Greek New Testament in the Light of Historical Research")]), _vm._v(" (London, n.d.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Robinson")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("John A. T. Robinson: "), _c('em', [_vm._v("Wrestling with Romans")]), _vm._v(" (London, 1979)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("RSV")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Revised Standard Version")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("RThR")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Reformed Theological Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("RV")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Revised Version")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBk")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("H. L. Strack und P. Billerbeck: "), _c('em', [_vm._v("Kommentar zum Neuen Testament aus Talmud und Midrasch,")]), _vm._v(" 4 vols. (München, 1922-28)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Schonfield")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hugh J. Schonfield: "), _c('em', [_vm._v("The Authentic New Testament")]), _vm._v(" (London, 1956)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Scott")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("E. F. Scott: "), _c('em', [_vm._v("Paul’s Epistle to the Romans")]), _vm._v(" (London, 1947)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SH")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("William Sanday and Arthur C. Headlam: "), _c('em', [_vm._v("A Critical and Exegetical Commentary on the Epistle to the Romans")]), _vm._v(" (Edinburgh, 1907)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Shedd")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("William G. T. Shedd: "), _c('em', [_vm._v("Commentary on Romans")]), _vm._v(" (Grand Rapids, 1980 repr. of 1879 edn.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Simeon")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Charles Simeon: "), _c('em', [_vm._v("Horae Homileticae,")]), _vm._v(" XV, "), _c('em', [_vm._v("Romans")]), _vm._v(" (London, 1847)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Smart")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("James D. Smart: "), _c('em', [_vm._v("Doorway to a New Age")]), _vm._v(" (New York, 1972)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Stott")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("John R. W. Stott: "), _c('em', [_vm._v("Men Made New")]), _vm._v(" (Downers Grove, 1966)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Synonyms")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Richard Chevenix Trench: "), _c('em', [_vm._v("Synonyms of the New Testament")]), _vm._v(" (London, 1880)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Tasker")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("R. V. G. Tasker, ed.: "), _c('em', [_vm._v("The Greek New Testament")]), _vm._v(" (Oxford and Cambridge, 1964)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("TDNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theological Dictionary of the New Testament,")]), _vm._v(" a translation by Geoffrey W. Bromiley of "), _c('em', [_vm._v("Theologisches Wörterbuch zum Neuen Testament")]), _vm._v(" (Grand Rapids, 1964-76)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("TH")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Barclay M. Newman and Eugene A. Nida: "), _c('em', [_vm._v("A Translator’s Handbook on Paul’s Letter to the Romans")]), _vm._v(" (New York, 1973)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Thomas")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("W. H. Griffith Thomas: "), _c('em', [_vm._v("Romans,")]), _vm._v(" 3 vols. (London, 1911-12)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Vaughan")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("C. J. Vaughan: "), _c('em', [_vm._v("St. Paul’s Epistle to the Romans")]), _vm._v(" (London, 1880)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Vermes")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("G. Vermes: "), _c('em', [_vm._v("The Dead Sea Scrolls in English")]), _vm._v(" (Harmondsworth, 1972)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Way")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Arthur S. Way: "), _c('em', [_vm._v("The Letters of St. Paul")]), _vm._v(" (London, 1921)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wesley")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("John Wesley: "), _c('em', [_vm._v("Explanatory Notes upon the New Testament")]), _vm._v(" (London, 1977)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Weymouth")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("R. F. Weymouth: "), _c('em', [_vm._v("The New Testament in Modern Speech")]), _vm._v(" (London, 1907)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WH")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("B. F. Westcott and F.J. Hort: "), _c('em', [_vm._v("The New Testament in the Original Greek")]), _vm._v(" (London, 1907)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wilckens")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ulrich Wilckens: "), _c('em', [_vm._v("Der Brief an die Römer,")]), _vm._v(" 3 vols. (Zürich, 1978-82)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wilson")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Geoffrey B. Wilson: "), _c('em', [_vm._v("Romans")]), _vm._v(" (Edinburgh, 1976)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WTJ")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Westminster Theological Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wuest")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Kenneth S. Wuest: "), _c('em', [_vm._v("Romans in the Greek New Testament")]), _vm._v(" (London, n.d.)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Quotations from the Talmud are from the Soncino edition, and the Mishnah is cited from Danby’s translation.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45ceb05d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_ChiefAbbreviations.vue
// module id = 75
// module chunks = 0